import type { EventLogEntry, PaginatedResult } from '@container-system/shared';
import { apiRequest, buildQuery } from './client';

export function listEvents(filter: { page?: number; pageSize?: number; userId?: string; from?: string; to?: string }) {
  return apiRequest<PaginatedResult<EventLogEntry>>(`/api/events${buildQuery(filter)}`);
}
